import { Injectable } from '@angular/core';
import { Ward } from '@delab/ngx-gen-ts-ixserv/models';
import { JsonConvert, OperationMode, ValueCheckingMode } from 'json2typescript';
import { map } from 'rxjs';
import { WardsApiService } from '../../../.api-client/services/wards-api.service';
import { AbstractCache } from './abstract-cache';

@Injectable({ providedIn: 'root' })
export class WardsCache extends AbstractCache<Ward[]> {
    private readonly _jsonConvert: JsonConvert = new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.ALLOW_NULL);

    constructor(private _wardsApiService: WardsApiService) {
        super();
    }

    protected _getCurrentValue() {
        return this._wardsApiService.wardsGetWards().pipe(
            map((serialized) => {
                return this._jsonConvert.deserializeArray(serialized, Ward);
            }),
        );
    }
}
